<template>
  <form class="form" @submit.prevent="handleSubmit(handleProceed)()">
    <div class="pb-12 form-fields">
      <div class="grid grid-cols-2 gap-6">
        <VFormInput
          label="First name*"
          placeholder="Enter first name"
          :initialValue="initialValues.first_name"
          :error="errors.first_name"
          @update="value => handleSetField('first_name', value)"
        />
        <VFormInput
          label="Last name*"
          placeholder="Enter last name"
          :initialValue="initialValues.last_name"
          :error="errors.last_name"
          @update="value => handleSetField('last_name', value)"
        />
      </div>

      <div class="grid grid-cols-2 gap-6">
        <VFormInput
          label="Email*"
          placeholder="Enter email address"
          inputType="text"
          :initialValue="initialValues.email"
          :error="errors.email"
          @update="value => handleSetField('email', value)"
        />
        <VFormInput
          label="Phone number*"
          placeholder="Enter phone number"
          :onlyDigits="true"
          :initialValue="initialValues.phone"
          :error="errors.phone"
          :formatValue="formatPhoneNumOnChange"
          @update="value => handleSetField('phone', value)"
        />
      </div>

      <div class="grid gap-6" :class="[editable ? 'grid-cols-2' : 'grid-cols-1']">
        <VFormInput
          label="Business name*"
          placeholder="Enter business name"
          :error="errors.company_name"
          :initialValue="initialValues.company_name"
          @update="value => handleSetField('company_name', value)"
        />
        <VFormInput
          v-if="editable"
          label="Customer's Netsuite ID*"
          placeholder="Enter Netsuite ID"
          :onlyDigits="true"
          :initialValue="initialValues.netsuite_id"
          :error="errors.netsuite_id"
          @update="value => handleSetField('netsuite_id', value)"
        />
      </div>

      <div class="grid grid-cols-2 gap-6">
        <VFormSelect
          label="Payout Amount Tags*"
          placeholder="Select payout amount tags"
          :options="payoutTags"
          optionKey="name"
          :initialSelectedOption="initialValues.referral_payout_tag"
          :error="errors.referral_payout_tag"
          @onSelect="value => handleSetField('referral_payout_tag', value)"
        />
      </div>
      <div class="grid grid-cols-2 gap-6">
        <VFormSelect
          label="Landing Page Template Emb*"
          placeholder="Select landing page template Emb"
          :options="templates"
          optionKey="name"
          :initialSelectedOption="initialValues.template"
          :error="errors.template"
          @onSelect="value => handleSetTemplate(value)"
        />
        <VFormSelect
          label="Landing Page Template Dtp*"
          placeholder="Select landing page template Dtp"
          :options="templates"
          optionKey="name"
          :initialSelectedOption="initialValues.template_dtp"
          :error="errors.template_dtp"
          @onSelect="value => handleSetTemplateDtp(value)"
        />
      </div>

      <div class="grid grid-cols-2 gap-6">
        <div class="h-48 p-1 overflow-hidden border rounded border-ricoma-gray-800">
          <div
            v-if="fieldsData.template && fieldsData.template.preview"
            class="relative w-full h-full"
            @click.prevent="$emit('preview', fieldsData.template)"
          >
            <div
              class="absolute top-0 left-0 flex flex-col items-center justify-center w-full h-full overflow-hidden rounded cursor-pointer"
            >
              <div class="absolute top-0 left-0 w-full h-full opacity-75 bg-ricoma-gray-500"></div>
              <VSvgIcon name="eye" class="z-10 inline-block w-12 h-12 text-white" />
              <div class="z-10 text-white uppercase">Preview</div>
            </div>
            <img
              :src="fieldsData.template.preview"
              alt="Referral landing page preview"
              class="object-cover w-full h-full rounded"
            />
          </div>
          <div v-else class="flex items-center justify-center w-full h-full text-center uppercase">
            Select a landing page template Emb <br />
            to preview
          </div>
        </div>
        <div class="h-48 p-1 overflow-hidden border rounded border-ricoma-gray-800">
          <div
            v-if="fieldsData.template_dtp && fieldsData.template_dtp.preview"
            class="relative w-full h-full"
            @click.prevent="$emit('previewDtp', fieldsData.template_dtp)"
          >
            <div
              class="absolute top-0 left-0 flex flex-col items-center justify-center w-full h-full overflow-hidden rounded cursor-pointer"
            >
              <div class="absolute top-0 left-0 w-full h-full opacity-75 bg-ricoma-gray-500"></div>
              <VSvgIcon name="eye" class="z-10 inline-block w-12 h-12 text-white" />
              <div class="z-10 text-white uppercase">Preview</div>
            </div>
            <img
              :src="fieldsData.template_dtp.preview"
              alt="Referral landing page preview"
              class="object-cover w-full h-full rounded"
            />
          </div>
          <div v-else class="flex items-center justify-center w-full h-full text-center uppercase">
            Select a landing page template Dtp <br />
            to preview
          </div>
        </div>
      </div>
      <div class="grid grid-cols-2 gap-6 mt-8">
        <VFormSelect
          label="Landing Page Template Dtg*"
          placeholder="Select landing page template Dtg"
          :options="templates"
          optionKey="name"
          :initialSelectedOption="initialValues.template_dtg"
          :error="errors.template_dtg"
          @onSelect="value => handleSetTemplateDtg(value)"
        />
      </div>
      <div class="grid grid-cols-2 gap-6">
        <div class="h-48 p-1 overflow-hidden border rounded border-ricoma-gray-800">
          <div
            v-if="fieldsData.template_dtg && fieldsData.template_dtg.preview"
            class="relative w-full h-full"
            @click.prevent="$emit('previewDtg', fieldsData.template_dtg)"
          >
            <div
              class="absolute top-0 left-0 flex flex-col items-center justify-center w-full h-full overflow-hidden rounded cursor-pointer"
            >
              <div class="absolute top-0 left-0 w-full h-full opacity-75 bg-ricoma-gray-500"></div>
              <VSvgIcon name="eye" class="z-10 inline-block w-12 h-12 text-white" />
              <div class="z-10 text-white uppercase">Preview</div>
            </div>
            <img
              :src="fieldsData.template_dtg.preview"
              alt="Referral landing page preview"
              class="object-cover w-full h-full rounded"
            />
          </div>
          <div v-else class="flex items-center justify-center w-full h-full text-center uppercase">
            Select a landing page template Dtg <br />
            to preview
          </div>
        </div>
      </div>
    </div>

    <div class="form-buttons">
      <button class="form-buttons-cancel" type="button" @click="() => $emit('close')">
        Cancel
      </button>
      <button type="submit" class="form-buttons-proceed" :disabled="formLoading">
        <BeatLoader
          v-if="formLoading"
          color="#FAFAFA"
          :size="0.875"
          sizeUnit="rem"
          class="flex items-center"
        />
        <span v-else>Add</span>
      </button>
    </div>
  </form>
</template>

<script>
import { formMixin } from '@/mixins';

import { isPhoneNum, isEmail, formatPhoneNumOnChange } from '@/utils';

import { BeatLoader } from '@saeris/vue-spinners';

import VFormInput from '@/components/base/VFormInput';
import VFormSelect from '@/components/base/VFormSelect';
import VSvgIcon from '@/components/base/VSvgIcon';

export default {
  name: 'CustomerForm',
  components: { BeatLoader, VFormInput, VFormSelect, VSvgIcon },
  props: {
    initialValues: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    payoutTags: {
      type: Array,
      required: false,
      default: () => [],
    },
    templates: {
      type: Array,
      required: false,
      default: () => [],
    },
    editable: {
      type: Boolean,
      required: false,
      default: false,
    },
    editableCustomer: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  mixins: [
    formMixin(
      {
        first_name: '',
        last_name: '',
        email: '',
        company_name: '',
        phone: '',
        netsuite_id: '',
        referral_payout_tag: null,
        template: null,
        template_dtp: null,
        template_dtg: null,
      },
      ['minimum_referrals', 'netsuite_id', 'machine_required'],
      [],
      [
        {
          field: 'phone',
          msg: 'Invalid phone number.',
          predicateFn: phone => !isPhoneNum(phone),
        },
        {
          field: 'email',
          msg: 'Invalid email address.',
          predicateFn: email => !isEmail(email),
        },
      ],
    ),
  ],
  methods: {
    formatPhoneNumOnChange: phone => formatPhoneNumOnChange(phone),
    handleSetTemplate(template) {
      this.handleSetField('template', template);
      this.$emit('template', template);
    },
    handleSetTemplateDtp(template) {
      this.handleSetField('template_dtp', template);
      this.$emit('template_dtp', template);
    },
    handleSetTemplateDtg(template) {
      this.handleSetField('template_dtg', template);
      this.$emit('template_dtp', template);
    },
    async handleProceed(data) {
      this.editable ? await this.handleUpdateCustomer(data) : await this.handleAddCustomer(data);
      this.handleResetFields();
      this.handleResetErrors();
      this.$emit('close');
    },
    async handleUpdateCustomer({
      referral_payout_tag,
      template,
      template_dtp,
      template_dtg,
      ...rest
    }) {
      const { id: customerId } = this.editableCustomer;
      const data = {
        referral_payout_tag: referral_payout_tag.id,
        template_id: template.id,
        template_dtp_id: template_dtp.id,
        template_dtg_id: template_dtg.id,
        ...rest,
      };
      await this.$store.dispatch('admin/updateCustomer', { customerId, data });
    },
    async handleAddCustomer({
      referral_payout_tag,
      template,
      template_dtp,
      template_dtg,
      ...rest
    }) {
      const data = {
        referral_payout_tag: referral_payout_tag.id,
        template_id: template.id,
        template_dtp_id: template_dtp.id,
        template_dtg_id: template_dtg.id,
        ...rest,
      };
      await this.$store.dispatch('admin/addCustomer', { data });
    },
  },
  mounted() {
    // We need to make some fields in the formMixing optional/required
    // in order to trigger the right condition in Workato
    this.ignoredFields = this.editable
      ? this.ignoredFields.filter(f => f !== 'netsuite_id')
      : ['minimum_referrals', 'netsuite_id'];
  },
};
</script>
